export const displayCremeExpectations = (result: number): JSX.Element => (
  <span>
    Na ten tort przewidujemy <strong>{result}</strong>
    {'g kremu '}
  </span>
)
